import { ICustomerMultiplier } from './types'

export const blankCustomerMultiplier: ICustomerMultiplier = {
  MaterialMultipliers: {},
  ProductMultipliers: {},
}
